import { render, staticRenderFns } from "./VehicleBatch.vue?vue&type=template&id=9277cfc0&scoped=true&"
import script from "./VehicleBatch.vue?vue&type=script&lang=js&"
export * from "./VehicleBatch.vue?vue&type=script&lang=js&"
import style0 from "./VehicleBatch.vue?vue&type=style&index=0&id=9277cfc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9277cfc0",
  null
  
)

export default component.exports